export default "__VITE_ASSET__CAnMe$7v__"